import { apiClient, REVIEW_REQUEST_CONFIGURATION } from '../../../../shared/api';

const WEBSITE_ID = 1; // TODO: Change WEBSITE_ID.

export const fetchReviewRequestConfiguration = async () => {
  const response = await apiClient.get(
    REVIEW_REQUEST_CONFIGURATION.replace(':websiteId', WEBSITE_ID)
  );

  return response.data;
};

export const updateReviewRequestConfiguration = async (
  reviewRequestConfigurationData
) => {
  const { confirmationMessage, content, sendEmail, sendSms, subject, title } =
    reviewRequestConfigurationData;

  const requestBody = {
    review_request_configuration: {
      confirmation_message: confirmationMessage,
      content,
      send_email: sendEmail,
      send_sms: sendSms,
      subject,
      title,
    },
  };

  const response = await apiClient.patch(
    REVIEW_REQUEST_CONFIGURATION.replace(':websiteId', WEBSITE_ID),
    requestBody
  );

  return response.data;
};
